/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { Box, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import InputField from "../../components/Layout/fieldInput/InputField";

function PersonalDetailsSearch({ onDetailsChange, personalDetails }) {
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    onDetailsChange(name, value);
  };

  return (
    <Box>
      <Box sx={{ width: "100%" }}>
        <Grid container rowSpacing={4} columnSpacing={5}>
          <Grid item md={12} xs={12}>
            <InputField
              label="Member Id"
              name="memberIds"
              value={personalDetails?.memberIds}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item md={12} xs={12}>
            <InputField
              label="Member Name"
              name="fullName"
              value={personalDetails?.fullName}
              onChange={handleInputChange}
            />
          </Grid>
        </Grid>
      </Box>
      <Grid item md={8} sm={12} spacing={2} />
    </Box>
  );
}
export default PersonalDetailsSearch;
